import React, { useState } from 'react';
import { ClockIcon, UsersIcon, BriefcaseIcon, MailIcon, GlobeIcon, PrinterIcon, MessageCircleIcon, LayersIcon, SettingsIcon, LogOutIcon, CpuIcon, MenuIcon, XIcon, PhoneIcon, PhoneIncomingIcon, PhoneOutgoingIcon, PhoneMissedIcon, BotIcon, CheckCircle2Icon, LockIcon, SmartphoneIcon, ArrowRightLeftIcon, PlusIcon, WifiIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTheme } from '../components/ThemeProvider';
import { PhoneDialer } from '../components/PhoneDialer';
import { KYCModal } from '../components/KYCModal';
import { PortingModal } from '../components/PortingModal';
import { AnimatePresence } from 'framer-motion';
const MOCK_CALL_LOGS = [{
  id: 1,
  name: 'Sarah Chen',
  number: '+1 (555) 102-9384',
  type: 'inbound',
  duration: '04:12',
  time: '10:42 AM',
  status: 'Completed',
  aiSummary: 'Client requested Q3 pricing update.'
}, {
  id: 2,
  name: 'Unknown',
  number: '+1 (555) 883-1192',
  type: 'missed',
  duration: '00:00',
  time: '09:15 AM',
  status: 'Missed',
  aiSummary: 'No voicemail left.'
}, {
  id: 3,
  name: 'Marcus Thorne',
  number: '+1 (555) 482-1102',
  type: 'outbound',
  duration: '12:45',
  time: 'Yesterday',
  status: 'Completed',
  aiSummary: 'Follow-up on hardware financing.'
}, {
  id: 4,
  name: 'Elena Rodriguez',
  number: '+1 (555) 992-3841',
  type: 'inbound',
  duration: '02:30',
  time: 'Yesterday',
  status: 'Completed',
  aiSummary: 'Technical deep dive on AVA AI.'
}, {
  id: 5,
  name: 'David Kim',
  number: '+1 (555) 221-0092',
  type: 'outbound',
  duration: '08:15',
  time: 'Oct 24',
  status: 'Completed',
  aiSummary: 'Scheduling demo for automation suite.'
}, {
  id: 6,
  name: 'TechFlow Inc.',
  number: '+1 (555) 334-9910',
  type: 'inbound',
  duration: '15:22',
  time: 'Oct 23',
  status: 'Completed',
  aiSummary: 'Discussed enterprise SLA terms.'
}];
const MENU_ITEMS = [{
  id: 'sims',
  label: 'SIM Management',
  icon: SmartphoneIcon
}, {
  id: 'dialer',
  label: 'Dialer',
  icon: PhoneIcon
}, {
  id: 'logs',
  label: 'Recent Logs',
  icon: ClockIcon
}, {
  id: 'crm',
  label: 'AVA-CRM',
  icon: UsersIcon
}, {
  id: 'enterprise',
  label: 'Enterprise Services',
  icon: BriefcaseIcon
}, {
  id: 'emails',
  label: 'Emails',
  icon: MailIcon
}, {
  id: 'domains',
  label: 'Domains',
  icon: GlobeIcon
}, {
  id: 'efax',
  label: 'E-Fax',
  icon: PrinterIcon
}, {
  id: 'whatsapp',
  label: 'WhatsApp',
  icon: MessageCircleIcon
}, {
  id: 'system',
  label: 'System Layer',
  icon: LayersIcon
}, {
  id: 'settings',
  label: 'Settings',
  icon: SettingsIcon
}];
export function Dashboard() {
  const [activeTab, setActiveTab] = useState('sims');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDialerOpen, setIsDialerOpen] = useState(true);
  const [kycTier, setKycTier] = useState<0 | 1 | 2>(0);
  const [isKYCModalOpen, setIsKYCModalOpen] = useState(false);
  const [isPortingModalOpen, setIsPortingModalOpen] = useState(false);
  const [kycType, setKycType] = useState<'consumer' | 'business'>('consumer');
  const {
    isDark,
    toggleTheme
  } = useTheme();
  const handleTriggerKYC = (type: 'consumer' | 'business') => {
    setKycType(type);
    setIsKYCModalOpen(true);
  };
  const handleKYCComplete = () => {
    setIsKYCModalOpen(false);
    setKycTier(kycType === 'consumer' ? 1 : 2);
  };
  return <div className="min-h-screen bg-gray-50 dark:bg-[#000000] text-black dark:text-[#FFFFFF] font-['Inter',sans-serif] flex transition-colors duration-300" data-id="element-602" data-mp="3val0u25rqkc9">
      {/* Sidebar (Desktop) */}
      <aside className="hidden md:flex w-64 bg-white dark:bg-[#0E131F] border-r border-gray-200 dark:border-white/10 flex-col h-screen sticky top-0 transition-colors duration-300" data-id="element-603" data-mp="464gt98wsrjq">
        <div className="p-6 border-b border-gray-200 dark:border-white/10 flex items-center transition-colors duration-300" data-id="element-604" data-mp="3qi1m31vchj5v">
          <Link to="/" className="flex items-center" data-id="element-605" data-mp="murlvrr35gxb">
            <img src="https://cdn.magicpatterns.com/uploads/wARv7Md6wddGeKdpXuv8BA/gemini-svg_(2).svg" alt="Effy Mobile" className="h-[68px] w-auto object-contain dark:bg-white dark:p-1.5 dark:rounded-lg transition-all" data-id="element-606" data-mp="mwcgtihbb1vp" />
          </Link>
        </div>

        <nav className="flex-1 overflow-y-auto py-6 px-4 space-y-2 no-scrollbar" data-id="element-607" data-mp="2ldehwghi8dx5">
          {MENU_ITEMS.map(item => {
          const isActive = activeTab === item.id && item.id !== 'dialer';
          return <button key={item.id} onClick={() => {
            if (item.id === 'dialer') {
              setIsDialerOpen(true);
            } else {
              setActiveTab(item.id);
            }
          }} className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-xs font-bold uppercase tracking-widest transition-all ${isActive ? 'bg-[#13E200]/10 text-[#13E200] dark:text-[#FFF200] border border-[#13E200]/20 shadow-none dark:shadow-[0_0_15px_rgba(0,255,102,0.1)]' : 'text-gray-500 dark:text-[#8F9CAE] hover:bg-gray-50 dark:hover:bg-white/5 hover:text-black dark:hover:text-[#FFFFFF]'}`} data-id="element-608" data-mp="3e2290soxpxim">
                <item.icon className={`w-4 h-4 ${isActive ? 'text-[#13E200]' : 'text-gray-500 dark:text-[#8F9CAE]'}`} data-id="element-609" data-mp="45v2trxurr0q" />
                {item.label}
              </button>;
        })}
        </nav>

        <div className="p-4 border-t border-gray-200 dark:border-white/10 transition-colors duration-300" data-id="element-610" data-mp="d5i3ucmo6ut9">
          <button className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-xs font-bold uppercase tracking-widest text-[#FF3366] hover:bg-[#FF3366]/10 transition-all" data-id="element-611" data-mp="i5e6o8jmsg78">
            <LogOutIcon className="w-4 h-4" data-id="element-612" data-mp="r5kgnkg4ey1n" />
            Sign Out
          </button>
        </div>
      </aside>

      {/* Main Content Area */}
      <main className="flex-1 flex flex-col h-screen overflow-hidden relative" data-id="element-613" data-mp="vxu5sy9evu2v">
        <header className="h-20 bg-white dark:bg-[#0E131F] border-b border-gray-200 dark:border-white/10 flex items-center justify-between px-4 md:px-8 shrink-0 transition-colors duration-300 z-20" data-id="element-614" data-mp="10ukhl9e6o3ih">
          <div className="flex items-center gap-3 md:hidden" data-id="element-615" data-mp="1auuvyxbyfgz8">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-black dark:text-white hover:text-[#13E200] transition-colors" data-id="element-616" data-mp="l5ntoy3ftpnw">
              {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-617" data-mp="g4gkqvpk6kfn" /> : <MenuIcon className="w-6 h-6" data-id="element-618" data-mp="uv7dc5yz5njt" />}
            </button>
            <Link to="/" className="flex items-center" data-id="element-619" data-mp="uxk3h6evz47y">
              <img src="https://cdn.magicpatterns.com/uploads/wARv7Md6wddGeKdpXuv8BA/gemini-svg_(2).svg" alt="Effy Mobile" className="h-[54px] w-auto object-contain dark:bg-white dark:p-1 dark:rounded-lg transition-all" data-id="element-620" data-mp="q4haaze0twsa" />
            </Link>
          </div>
          <h1 className="text-lg md:text-2xl font-black text-black dark:text-[#FFF200] uppercase tracking-widest drop-shadow-none dark:drop-shadow-[0_0_8px_rgba(255,242,0,0.5)] transition-colors duration-300 truncate" data-id="element-621" data-mp="yzf1o21it1hi">
            {MENU_ITEMS.find(i => i.id === activeTab)?.label}
          </h1>
          <div className="flex items-center gap-4" data-id="element-622" data-mp="3fnj8b70mwx6c">
            <div className="flex items-center gap-2 px-2 md:px-3 py-1.5 rounded-full bg-[#13E200]/10 border border-[#13E200]/20" data-id="element-623" data-mp="3ann3j5k451pq">
              <div className="w-2 h-2 rounded-full bg-[#13E200] animate-pulse shadow-none dark:shadow-[0_0_8px_rgba(0,255,102,0.8)]" data-id="element-624" data-mp="1q5cit8iyz3lx" />
              <span className="hidden sm:inline text-[10px] font-black text-[#13E200] uppercase tracking-widest" data-id="element-625" data-mp="1gf13yqxqza09">System Online</span>
            </div>
          </div>
        </header>

        {/* Mobile Nav Dropdown */}
        {isMobileMenuOpen && <div className="md:hidden absolute top-20 left-0 right-0 bg-white dark:bg-[#0E131F] border-b border-gray-200 dark:border-white/10 shadow-lg z-10 max-h-[calc(100vh-5rem)] overflow-y-auto" data-id="element-626" data-mp="17da2jya8ppc7">
            <div className="p-4 space-y-2" data-id="element-627" data-mp="xh6yunzqpin5">
              {MENU_ITEMS.map(item => {
            const isActive = activeTab === item.id && item.id !== 'dialer';
            return <button key={item.id} onClick={() => {
              if (item.id === 'dialer') {
                setIsDialerOpen(true);
              } else {
                setActiveTab(item.id);
              }
              setIsMobileMenuOpen(false);
            }} className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-xs font-bold uppercase tracking-widest transition-all ${isActive ? 'bg-[#13E200]/10 text-[#13E200] dark:text-[#FFF200] border border-[#13E200]/20 shadow-none dark:shadow-[0_0_15px_rgba(0,255,102,0.1)]' : 'text-gray-500 dark:text-[#8F9CAE] hover:bg-gray-50 dark:hover:bg-white/5 hover:text-black dark:hover:text-[#FFFFFF]'}`} data-id="element-628" data-mp="2rtepvq8xxfdn">
                    <item.icon className={`w-4 h-4 ${isActive ? 'text-[#13E200]' : 'text-gray-500 dark:text-[#8F9CAE]'}`} data-id="element-629" data-mp="10tankwcc8dpv" />
                    {item.label}
                  </button>;
          })}
              <div className="pt-4 mt-4 border-t border-gray-200 dark:border-white/10" data-id="element-630" data-mp="rx33zl4o2v1x">
                <button className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-xs font-bold uppercase tracking-widest text-[#FF3366] hover:bg-[#FF3366]/10 transition-all" data-id="element-631" data-mp="mxqf6uu8jdwp">
                  <LogOutIcon className="w-4 h-4" data-id="element-632" data-mp="2hagbfj82sz79" />
                  Sign Out
                </button>
              </div>
            </div>
          </div>}

        <div className="flex-1 overflow-y-auto p-4 md:p-8" data-id="element-633" data-mp="2ts94f67pdxli">
          {kycTier === 0 ? <div className="max-w-3xl mx-auto" data-id="element-634" data-mp="2tq68k5jvda8v">
              <div className="bg-white dark:bg-[#0E131F] border border-gray-200 dark:border-white/10 rounded-3xl p-8 shadow-lg transition-colors duration-300" data-id="element-635" data-mp="2ykagos4vfobj">
                <div className="flex items-center gap-4 mb-8" data-id="element-636" data-mp="25uk2kj38omff">
                  <div className="w-16 h-16 bg-gray-100 dark:bg-white/5 rounded-full flex items-center justify-center" data-id="element-637" data-mp="25wejznfaxwer">
                    <div className="w-4 h-4 bg-gray-400 rounded-full" data-id="element-638" data-mp="2avhpta33w6ns"></div>
                  </div>
                  <div data-id="element-639" data-mp="2fv44lnyl1uyp">
                    <h2 className="text-2xl font-black text-black dark:text-white uppercase tracking-widest" data-id="element-640" data-mp="2juurvhowhsyh">Identity Not Verified</h2>
                    <p className="text-sm text-gray-500 dark:text-[#8F9CAE] font-medium" data-id="element-641" data-mp="3r750rnxs0loh">Tier 0 Access Level</p>
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-8 mb-8" data-id="element-642" data-mp="1l52t7ahz6jmb">
                  <div data-id="element-643" data-mp="1l2qhhf2t95hp">
                    <h3 className="text-xs font-bold uppercase tracking-widest text-gray-500 dark:text-[#8F9CAE] mb-4" data-id="element-644" data-mp="1q3w73416ccn0">Available Features</h3>
                    <ul className="space-y-3" data-id="element-645" data-mp="1uvxjcpyce3d1">
                      {['Browse Plans', 'Hardware Store', 'Coverage Checker', 'Number Search'].map(f => <li key={f} className="flex items-center gap-3 text-sm font-medium text-black dark:text-white" data-id="element-646" data-mp="1zvs8anyk4ivg">
                          <CheckCircle2Icon className="w-4 h-4 text-[#13E200]" data-id="element-647" data-mp="1751w864tzwc4" /> {f}
                        </li>)}
                    </ul>
                  </div>
                  <div data-id="element-648" data-mp="1c2jwl84s938i">
                    <h3 className="text-xs font-bold uppercase tracking-widest text-gray-500 dark:text-[#8F9CAE] mb-4" data-id="element-649" data-mp="1c6hhnzax84v1">Locked Features</h3>
                    <ul className="space-y-3" data-id="element-650" data-mp="2nk34vex7zwdx">
                      {['Activate SIM', 'Buy Phone Number', 'Port Number', 'Home Internet', 'SMS', 'Voice Calls'].map(f => <li key={f} className="flex items-center gap-3 text-sm font-medium text-gray-400 dark:text-gray-600" data-id="element-651" data-mp="2skhev2idtgel">
                          <LockIcon className="w-4 h-4" data-id="element-652" data-mp="bw6n9oc1jgej" /> {f}
                        </li>)}
                    </ul>
                  </div>
                </div>

                <button onClick={() => handleTriggerKYC('consumer')} className="w-full bg-[#13E200] hover:bg-[#10c000] text-black font-black uppercase tracking-widest py-4 rounded-xl transition-colors shadow-[0_0_20px_rgba(19,226,0,0.3)]" data-id="element-653" data-mp="73dij0gko82g">
                  Verify Identity
                </button>
              </div>
            </div> : activeTab === 'settings' ? <div className="bg-white dark:bg-[#0E131F] border border-gray-200 dark:border-white/10 rounded-3xl p-8 shadow-lg max-w-2xl mx-auto transition-colors duration-300" data-id="element-654" data-mp="3kb868mt7sk2o">
              <h2 className="text-2xl font-black text-black dark:text-white uppercase tracking-widest mb-6 transition-colors duration-300" data-id="element-655" data-mp="1ikd8vqjd0ctu">Appearance Settings</h2>
              <div className="flex items-center justify-between p-4 bg-gray-50 dark:bg-black/50 rounded-xl border border-gray-200 dark:border-white/5 transition-colors duration-300" data-id="element-656" data-mp="1dltkljhamoyb">
                <div data-id="element-657" data-mp="3ct0ly1yk78ec">
                  <h3 className="text-lg font-bold text-black dark:text-white transition-colors duration-300" data-id="element-658" data-mp="3ctju4qyeqif6">Dark Mode</h3>
                  <p className="text-sm text-gray-500 dark:text-[#8F9CAE] transition-colors duration-300" data-id="element-659" data-mp="2y1i03nj0qjn2">Toggle between light and dark themes.</p>
                </div>
                <button onClick={toggleTheme} className={`w-14 h-8 rounded-full p-1 transition-colors duration-300 ${isDark ? 'bg-[#13E200]' : 'bg-gray-300'}`} data-id="element-660" data-mp="3qsjkc31kj5dg">
                  <div className={`w-6 h-6 bg-white rounded-full shadow-md transform transition-transform duration-300 ${isDark ? 'translate-x-6' : 'translate-x-0'}`} data-id="element-661" data-mp="3gultr8w8kwho" />
                </button>
              </div>
            </div> : activeTab === 'sims' ? <div className="max-w-5xl mx-auto space-y-8" data-id="element-662" data-mp="25dcdev8emkkl">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8" data-id="element-663" data-mp="2ae0bu1yyq3ou">
                <div data-id="element-664" data-mp="sfc4ljw4md41">
                  <h2 className="text-2xl font-black text-black dark:text-white uppercase tracking-widest transition-colors duration-300" data-id="element-665" data-mp="sek7u5qsm9c6">SIM Management</h2>
                  <p className="text-sm text-gray-500 dark:text-[#8F9CAE] font-medium mt-1" data-id="element-666" data-mp="11gjtxcgo03lz">Manage your physical SIMs, eSIMs, and number porting.</p>
                </div>
              </div>

              {/* Quick Actions */}
              <div className="grid md:grid-cols-2 gap-4" data-id="element-667" data-mp="9qp0p4ports1">
                <button className="bg-white dark:bg-[#0E131F] border border-gray-200 dark:border-white/10 hover:border-[#13E200] dark:hover:border-[#13E200] rounded-2xl p-6 flex items-start gap-4 text-left transition-colors group shadow-sm" data-id="element-668" data-mp="4qj7hk3rpz7u">
                  <div className="w-12 h-12 bg-[#13E200]/10 rounded-xl flex items-center justify-center shrink-0 group-hover:bg-[#13E200] transition-colors" data-id="element-669" data-mp="dqfn6w86jnqr">
                    <PlusIcon className="w-6 h-6 text-[#13E200] group-hover:text-black transition-colors" data-id="element-670" data-mp="3i5p7qatoc1n9" />
                  </div>
                  <div data-id="element-671" data-mp="3uvpususfgyw2">
                    <h3 className="text-sm font-black text-black dark:text-white uppercase tracking-wider mb-1" data-id="element-672" data-mp="3uw9a03qp196e">Order New SIM</h3>
                    <p className="text-xs text-gray-500 dark:text-[#8F9CAE] leading-relaxed" data-id="element-673" data-mp="3m0zkdowqv8d">Instantly activate an eSIM or request a physical SIM card delivery.</p>
                  </div>
                </button>
                
                <button onClick={() => setIsPortingModalOpen(true)} className="bg-white dark:bg-[#0E131F] border border-gray-200 dark:border-white/10 hover:border-[#13E200] dark:hover:border-[#13E200] rounded-2xl p-6 flex items-start gap-4 text-left transition-colors group shadow-sm" data-id="element-674" data-mp="idt2trbfgitq">
                  <div className="w-12 h-12 bg-blue-500/10 rounded-xl flex items-center justify-center shrink-0 group-hover:bg-blue-500 transition-colors" data-id="element-675" data-mp="wc9hq5jg1fmy">
                    <ArrowRightLeftIcon className="w-6 h-6 text-blue-500 group-hover:text-white transition-colors" data-id="element-676" data-mp="2y3w39rkkgic1" />
                  </div>
                  <div data-id="element-677" data-mp="2qmg1pgyet9wk">
                    <h3 className="text-sm font-black text-black dark:text-white uppercase tracking-wider mb-1" data-id="element-678" data-mp="2qmpsh6ra3l3b">Port Existing Number</h3>
                    <p className="text-xs text-gray-500 dark:text-[#8F9CAE] leading-relaxed" data-id="element-679" data-mp="2gua9q785qshd">Transfer your current phone number to the Effy Mobile network securely.</p>
                  </div>
                </button>
              </div>

              {/* Active SIMs */}
              <div data-id="element-680" data-mp="34ko2y12haxdj">
                <h3 className="text-sm font-bold uppercase tracking-widest text-gray-500 dark:text-[#8F9CAE] mb-4" data-id="element-681" data-mp="34k4m6nokef13">Active Lines</h3>
                <div className="grid md:grid-cols-2 gap-4" data-id="element-682" data-mp="2zk9wgngizvhm">
                  {/* eSIM Card */}
                  <div className="bg-white dark:bg-[#0E131F] border border-gray-200 dark:border-white/10 rounded-2xl p-6 relative overflow-hidden shadow-sm" data-id="element-683" data-mp="2ulosqe22etof">
                    <div className="absolute top-0 right-0 p-4" data-id="element-684" data-mp="1j7kyr7vh95jd">
                      <span className="px-2 py-1 bg-[#13E200]/10 text-[#13E200] text-[10px] font-black rounded uppercase tracking-widest border border-[#13E200]/20" data-id="element-685" data-mp="1j9flmrqb77q3">Active</span>
                    </div>
                    <div className="flex items-center gap-4 mb-6" data-id="element-686" data-mp="f7d6f40nqbrs">
                      <div className="w-12 h-12 bg-gray-50 dark:bg-black/50 rounded-xl flex items-center justify-center border border-gray-200 dark:border-white/5" data-id="element-687" data-mp="18wrwqwjzgz3">
                        <WifiIcon className="w-6 h-6 text-black dark:text-white" data-id="element-688" data-mp="3nor9omb2a1w5" />
                      </div>
                      <div data-id="element-689" data-mp="3sg98b3pm3qdy">
                        <h4 className="text-lg font-black text-black dark:text-white tracking-wider" data-id="element-690" data-mp="3shkbp2f5aw4j">+1 (555) 102-9384</h4>
                        <p className="text-xs text-gray-500 dark:text-[#8F9CAE] font-medium uppercase tracking-widest" data-id="element-691" data-mp="3emi1w476gmmg">eSIM • Primary Line</p>
                      </div>
                    </div>
                    <div className="space-y-3" data-id="element-692" data-mp="34shxy5nmtnfb">
                      <div className="flex justify-between text-xs font-medium" data-id="element-693" data-mp="39prjha7whexv">
                        <span className="text-gray-500 dark:text-[#8F9CAE]" data-id="element-694" data-mp="2q3g6qyxtllio">Data Usage</span>
                        <span className="text-black dark:text-white font-mono" data-id="element-695" data-mp="2m2e7ii3wl9gp">12.4 GB / 30 GB</span>
                      </div>
                      <div className="h-1.5 w-full bg-gray-100 dark:bg-white/10 rounded-full overflow-hidden" data-id="element-696" data-mp="3025q6w5d7e11">
                        <div className="h-full bg-[#13E200] w-[40%]" data-id="element-697" data-mp="2v21b9ak3urcx"></div>
                      </div>
                    </div>
                    <div className="mt-6 flex gap-2" data-id="element-698" data-mp="390hg0vyeq7sf">
                      <button className="flex-1 py-2 bg-gray-50 dark:bg-white/5 hover:bg-gray-100 dark:hover:bg-white/10 rounded-lg text-[10px] font-bold uppercase tracking-widest text-black dark:text-white transition-colors" data-id="element-699" data-mp="351s5db4r74ch">Manage</button>
                      <button className="flex-1 py-2 bg-gray-50 dark:bg-white/5 hover:bg-gray-100 dark:hover:bg-white/10 rounded-lg text-[10px] font-bold uppercase tracking-widest text-black dark:text-white transition-colors" data-id="element-700" data-mp="3du2eep3wx3s5">View Plan</button>
                    </div>
                  </div>

                  {/* Physical SIM Card */}
                  <div className="bg-white dark:bg-[#0E131F] border border-gray-200 dark:border-white/10 rounded-2xl p-6 relative overflow-hidden shadow-sm" data-id="element-701" data-mp="2ddyypg27pm0s">
                    <div className="absolute top-0 right-0 p-4" data-id="element-702" data-mp="2ie3e12rdwapf">
                      <span className="px-2 py-1 bg-[#13E200]/10 text-[#13E200] text-[10px] font-black rounded uppercase tracking-widest border border-[#13E200]/20" data-id="element-703" data-mp="2nbdd7a4ks0qg">Active</span>
                    </div>
                    <div className="flex items-center gap-4 mb-6" data-id="element-704" data-mp="1uosmmbvxbsny">
                      <div className="w-12 h-12 bg-gray-50 dark:bg-black/50 rounded-xl flex items-center justify-center border border-gray-200 dark:border-white/5" data-id="element-705" data-mp="1zn3wunq4s56p">
                        <SmartphoneIcon className="w-6 h-6 text-black dark:text-white" data-id="element-706" data-mp="24fn9nigzuwag" />
                      </div>
                      <div data-id="element-707" data-mp="1bx9lybpdgqp3">
                        <h4 className="text-lg font-black text-black dark:text-white tracking-wider" data-id="element-708" data-mp="1bwgbaznalh1o">+1 (555) 482-1102</h4>
                        <p className="text-xs text-gray-500 dark:text-[#8F9CAE] font-medium uppercase tracking-widest" data-id="element-709" data-mp="3p682nnj1c804">Physical SIM • IoT Device</p>
                      </div>
                    </div>
                    <div className="space-y-3" data-id="element-710" data-mp="3g5jl4iufnpih">
                      <div className="flex justify-between text-xs font-medium" data-id="element-711" data-mp="3b7qghu8s33kb">
                        <span className="text-gray-500 dark:text-[#8F9CAE]" data-id="element-712" data-mp="3b9umchq8mcn8">Data Usage</span>
                        <span className="text-black dark:text-white font-mono" data-id="element-713" data-mp="36arobh8od6or">4.2 GB / 10 GB</span>
                      </div>
                      <div className="h-1.5 w-full bg-gray-100 dark:bg-white/10 rounded-full overflow-hidden" data-id="element-714" data-mp="2xg3klviqzx22">
                        <div className="h-full bg-[#13E200] w-[42%]" data-id="element-715" data-mp="2shsadjojjkjb"></div>
                      </div>
                    </div>
                    <div className="mt-6 flex gap-2" data-id="element-716" data-mp="2ngui2e9tha43">
                      <button className="flex-1 py-2 bg-gray-50 dark:bg-white/5 hover:bg-gray-100 dark:hover:bg-white/10 rounded-lg text-[10px] font-bold uppercase tracking-widest text-black dark:text-white transition-colors" data-id="element-717" data-mp="2ij2ozgxfrhyb">Manage</button>
                      <button className="flex-1 py-2 bg-gray-50 dark:bg-white/5 hover:bg-gray-100 dark:hover:bg-white/10 rounded-lg text-[10px] font-bold uppercase tracking-widest text-black dark:text-white transition-colors" data-id="element-718" data-mp="2ccoa5t39a1ax">View Plan</button>
                    </div>
                  </div>
                </div>
              </div>
            </div> : activeTab === 'logs' ? <div className="max-w-5xl mx-auto" data-id="element-719" data-mp="1tlf3drkvdqn1">
              <div className="flex items-center justify-between mb-8" data-id="element-720" data-mp="1tjkgw8ty9qgu">
                <h2 className="text-2xl font-black text-black dark:text-white uppercase tracking-widest transition-colors duration-300" data-id="element-721" data-mp="1olam3zc50rvr">Recent Call Logs</h2>
                <button className="text-xs font-bold uppercase tracking-widest text-[#13E200] hover:text-black dark:hover:text-white transition-colors" data-id="element-722" data-mp="1jl4mnwzmm134">
                  Export CSV
                </button>
              </div>
              <div className="space-y-4" data-id="element-723" data-mp="3ma5ygclob8zq">
                {MOCK_CALL_LOGS.map(log => <div key={log.id} className="bg-white dark:bg-[#0E131F] border border-gray-200 dark:border-white/10 rounded-2xl p-4 sm:p-6 flex flex-col sm:flex-row sm:items-center justify-between gap-4 shadow-sm hover:border-[#13E200] dark:hover:border-[#13E200] transition-colors group" data-id="element-724" data-mp="3mbz6nwbxq19u">
                    <div className="flex items-center gap-4" data-id="element-725" data-mp="41xa3t9repbi">
                      <div className={`w-12 h-12 rounded-xl flex items-center justify-center shrink-0 ${log.type === 'inbound' ? 'bg-blue-500/10 text-blue-500' : log.type === 'outbound' ? 'bg-green-500/10 text-green-500' : 'bg-red-500/10 text-red-500'}`} data-id="element-726" data-mp="33k6h6bw2qy6v">
                        {log.type === 'inbound' && <PhoneIncomingIcon className="w-6 h-6" data-id="element-727" data-mp="3hatb7qqw3zwm" />}
                        {log.type === 'outbound' && <PhoneOutgoingIcon className="w-6 h-6" data-id="element-728" data-mp="2jvp69tbq8so9" />}
                        {log.type === 'missed' && <PhoneMissedIcon className="w-6 h-6" data-id="element-729" data-mp="2otqqihkw2y1b" />}
                      </div>
                      <div data-id="element-730" data-mp="3s4wiyktuyre2">
                        <h3 className="text-sm font-black text-black dark:text-white uppercase tracking-wider" data-id="element-731" data-mp="3s44m76oiynm7">{log.name}</h3>
                        <p className="text-xs font-mono text-gray-500 dark:text-[#8F9CAE] mt-1" data-id="element-732" data-mp="3n5taeqeo631c">{log.number}</p>
                      </div>
                    </div>
                    
                    <div className="flex items-center justify-between sm:justify-end gap-6 sm:gap-12 w-full sm:w-auto" data-id="element-733" data-mp="rs0ueqfaaee">
                      <div className="flex flex-col sm:items-end" data-id="element-734" data-mp="396k4cjk6gpb3">
                        <span className="text-xs font-bold text-black dark:text-white uppercase tracking-widest" data-id="element-735" data-mp="3488u47pz0csc">{log.time}</span>
                        <span className="text-[10px] font-mono text-gray-500 dark:text-[#8F9CAE] mt-1" data-id="element-736" data-mp="3i89uzn68jk7t">{log.duration}</span>
                      </div>
                      
                      <button className="flex items-center gap-2 px-3 py-2 bg-gray-50 dark:bg-white/5 hover:bg-[#13E200]/10 dark:hover:bg-[#13E200]/10 rounded-lg text-[10px] font-bold uppercase tracking-widest text-gray-600 dark:text-gray-300 hover:text-[#13E200] dark:hover:text-[#13E200] transition-colors border border-gray-200 dark:border-white/10 hover:border-[#13E200]/30" data-id="element-737" data-mp="xfg6hx9asah2">
                        <BotIcon className="w-4 h-4" data-id="element-738" data-mp="r1aqglrjw1e5" />
                        <span className="hidden sm:inline" data-id="element-739" data-mp="r2u4e5pqi0cr">AI Summary</span>
                      </button>
                    </div>
                  </div>)}
              </div>
            </div> : <div className="bg-white dark:bg-[#0E131F] border border-gray-200 dark:border-white/10 rounded-3xl p-8 min-h-full flex items-center justify-center shadow-lg transition-colors duration-300" data-id="element-740" data-mp="1jpydomvv10uc">
              <div className="text-center" data-id="element-741" data-mp="19z3hapowgkv6">
                <div className="w-16 h-16 bg-[#13E200]/10 rounded-2xl flex items-center justify-center mx-auto mb-6 border border-[#13E200]/20 transition-colors duration-300" data-id="element-742" data-mp="1exwt8dojg3t8">
                  {React.createElement(MENU_ITEMS.find(i => i.id === activeTab)?.icon || LayersIcon, {
                className: "w-8 h-8 text-[#13E200]"
              })}
                </div>
                <h2 className="text-xl font-black text-black dark:text-[#FFFFFF] uppercase tracking-widest mb-2 transition-colors duration-300" data-id="element-743" data-mp="iqlfrfzwu1n3">
                  {MENU_ITEMS.find(i => i.id === activeTab)?.label} Module
                </h2>
                <p className="text-gray-500 dark:text-[#8F9CAE] text-sm font-medium max-w-md mx-auto transition-colors duration-300" data-id="element-744" data-mp="4tyitd7yjbh6">
                  This module is currently running in autonomous mode. Real-time data and controls will populate here.
                </p>
              </div>
            </div>}
        </div>
      </main>
      
      {/* Dialer FAB */}
      <AnimatePresence data-id="element-745" data-mp="ns10t823885h">
        {!isDialerOpen && <button onClick={() => setIsDialerOpen(true)} className="fixed bottom-4 right-4 md:bottom-6 md:right-6 z-[110] w-14 h-14 md:w-16 md:h-16 bg-[#13E200] rounded-full flex items-center justify-center shadow-[0_0_30px_rgba(19,226,0,0.4)] hover:scale-110 transition-transform" data-id="element-746" data-mp="nqzqj5swbpot">
            <PhoneIcon className="w-6 h-6 md:w-8 md:h-8 text-black fill-current" data-id="element-747" data-mp="1nsmm21ddllx4" />
          </button>}
      </AnimatePresence>

      <PhoneDialer isOpen={isDialerOpen} onClose={() => setIsDialerOpen(false)} data-id="element-748" data-mp="1srphcu3k0drw" />
      <KYCModal isOpen={isKYCModalOpen} onClose={() => setIsKYCModalOpen(false)} onComplete={handleKYCComplete} type={kycType} data-id="element-749" data-mp="1xpr7u03b7fde" />
      <PortingModal isOpen={isPortingModalOpen} onClose={() => setIsPortingModalOpen(false)} data-id="element-750" data-mp="22qoog88o81cs" />
    </div>;
}